<mat-form-field appearance="outline" bmTheme="find-tracks-input">
  <mat-label>{{ lg.sortTrackBy.beat.label }}</mat-label>
  <div class="find-tracks__input-box">
    <input
      matInput
      type="text"
      class="theme-inputMU__searchText"
      [(ngModel)]="searchTrack"
      (ngModelChange)="changeBeatValue({ search: $event, searchType: 'name' })"
    />
    @if (searchTrack) {
      <span
        class="btv-icon-close theme-inputMU__closeIcon"
        (click)="changeBeatValue({ search: '', searchType: 'name' })"
      ></span>
    }
  </div>
</mat-form-field>
